import React from 'react';
import Tracker from 'tracker';
import RejectVendor from 'components/events/rejectVendor';

class VendorStrip extends React.Component {
    constructor(props) {
        super(props);

        this.tracker = new Tracker();

        this.handleRejected = this.handleRejected.bind(this);
        this.handleProfileClick = this.handleProfileClick.bind(this);
    }

    getVendorLogo() {
        if (this.props.vendor.logo_url && !this.props.vendor.hide_logo_on_messages) {
            return <img src={this.props.vendor.logo_url} className="vendor-logo" alt={this.props.vendor.name} />;
        }

        return null;
    }

    getVendorType() {
        if (this.props.vendor.type === 'other') {
            return 'Vendor';
        }

        const type = this.props.vendor.type;
        return type[0].toUpperCase() + type.substring(1);
    }

    getVendorName() {
        if (!this.props.vendor.logo_url || this.props.vendor.hide_logo_on_messages) {
            return <span>{this.props.vendor.name}</span>;
        }

        return null;
    }

    getVendorActions() {
        if (!this.props.includeActions) {
            return null;
        }

        const lead = this.props.lead;
        if (lead.options.rejected) {
            return (
                <div className="vendor-actions">
                    <strong>You've passed on this {this.getVendorType().toLowerCase()}.</strong>
                </div>
            );
        }

        return (
            <div className="vendor-actions">
                <RejectVendor event={this.props.event} vendor={this.props.vendor} lead={lead} onRejected={this.handleRejected} />
            </div>
        );
    }

    handleRejected(lead) {
        this.props.onRejected(lead);
    }

    render() {
        const vendor = this.props.vendor;

        if (!vendor.slug) {
            return (
                <div className="vendor-strip">
                    <div className="vendor-name">{vendor.name}</div>
                    {this.getVendorActions()}
                </div>
            );
        }

        return (
            <div className="vendor-strip">
                <div className="vendor-name">
                    <a href={`/vendor/${vendor.slug}`} target="_blank" rel="noopener noreferrer" className="vendor-display">
                        {this.getVendorLogo()}
                        {this.getVendorName()}
                    </a>

                    <a href={`/vendor/${vendor.slug}`} target="_blank" rel="noopener noreferrer" className="btn btn-default profile-link">
                        View {this.getVendorType()} Profile
                    </a>
                </div>

                {this.getVendorActions()}
            </div>
        );
    }
}

VendorStrip.propTypes = {
    vendor: React.PropTypes.object.isRequired,
    event: React.PropTypes.object,
    onRejected: React.PropTypes.func,
    includeActions: React.PropTypes.bool,
};

VendorStrip.defaultProps = {
    event: {},
    onRejected: () => {},
    includeActions: true,
};

export default VendorStrip;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/vendorStrip.jsx